import React from "react";
import Alert from "./Alert";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  // 2026-07-04 tools-wide overhaul (operator-approved), audit item Tier 1 #4 :
  // the error argument is required by the React lifecycle signature but this
  // boundary only flips the fallback flag here (componentDidCatch stores the
  // error detail) ; underscore-prefixed to satisfy no-unused-vars.
  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    this.setState({
      error,
      errorInfo,
    });

    // You can also log the error to an error reporting service here
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI.
      // 2026-07-05 operator directive (site-wide dark-mode adaptation) : the
      // root div is a full-viewport page background, so it takes the solid
      // dark:bg-gray-900 page treatment (matching the body / Layout.jsx
      // root), NOT the translucent dark:bg-gray-900/50 inset-panel treatment
      // used for boxes that sit inside a card.
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
          <div className="max-w-2xl w-full">
            <Alert type="error" title="Something Went Wrong">
              An unexpected error occurred. Please refresh the page and try
              again.
            </Alert>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800/50 rounded-lg">
                <h3 className="text-sm font-semibold text-red-800 dark:text-red-200 mb-2">
                  Error Details (Development Only):
                </h3>
                <pre className="text-xs text-red-700 dark:text-red-300 overflow-auto">
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>
            )}
            <div className="mt-4 text-center">
              {/* 2026-07-05 dark-mode sweep found this button referencing
                  bg-primary / hover:bg-primary-dark, neither of which
                  existed, so Tailwind never generated them and the button
                  rendered white text on a transparent background in BOTH
                  themes. (This note used to add that the primary palette
                  "has numbered shades but no DEFAULT". That palette was
                  DELETED on 2026-08-25 - it was referenced nowhere, and
                  this comment was the evidence for that. There is no
                  primary colour of any kind now, numbered or otherwise.) Switched to the shared .btn classes from
                  src/client/styles/index.css : the site-standard, dark-aware
                  primary button treatment. */}
              <button
                onClick={() => window.location.reload()}
                className="btn btn-primary btn-md"
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
